'use strict';

/**
 * Keys are internal city names, while values are purely to speed up angular filters.
 * For instance, a user would sign up for the 'New York City area', but Vero
 * would track the user's city as 'New York'. That value would be stored as
 * 'New York' even on the front-end, but an angular filter would display the value.
 *
 */
var _clone = require('lodash/clone');
var newYorkCityTaxes = {
  name: 'New York City area',
  tax: 8.875,
  nonfbTax: 8.875
};
var bostonTaxes = {
  name: 'Boston area',
  tax: 7,
  nonfbTax: 6.25
};

module.exports = {
  // New York
  'Brooklyn': _clone(newYorkCityTaxes),
  'Bronx': _clone(newYorkCityTaxes),
  'New York': _clone(newYorkCityTaxes),
  'Queens': _clone(newYorkCityTaxes),
  'Staten Island': _clone(newYorkCityTaxes),

  // Washington DC
  'Washington': { name: 'Washington D.C. area', tax: 10, nonfbTax: 5.750 },

  // Boston
  'Boston': _clone(bostonTaxes),
  'Cambridge': _clone(bostonTaxes),

  'Chicago': { name: 'Chicago area' }
};